import { Component, OnInit, OnDestroy } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';

@Component({
    selector: 'dashboard.login',
    template: require('./login.component.html'),
    styles: [require('./login.component.css')]
})

export class LoginComponent implements OnInit, OnDestroy {
	model: any = {};
    loading = false;
    returnUrl: string;
    dashboards: Array<any> = [];
    queryParams: any;

	constructor(
        private dataservice: DataService,
        private route: ActivatedRoute,
        private router: Router) { 
        }

	ngOnInit() {
        let self = this;
        
        this.initialize();
        
        this.dataservice.logout(this.returnUrl, this.queryParams);
        
        // get return url from route parameters or default to '/'
        
        //console.log(this.returnUrl);
    }

    login (){
        var self = this;
        this.initialize();
        this.model.message = '';
        this.loading = true;
        this.dataservice.authenticate(this.model.username, this.model.password)
            .subscribe(
                data => {
                    //console.log(this);
                    if(data) {
                        localStorage.setItem('userId', this.model.username);                       
                        this.dataservice.getConfiguration().subscribe(dashboards => {
                            self.dashboards = dashboards;
                            let matched = false;
                            for (let i = 0; i < self.dashboards.length; i++) {
                                if ('/' + self.dashboards[i].template + '/' + self.dashboards[i].id === self.returnUrl) {
                                    matched = true;
                                    break;
                                }
                            }

                            if (!matched) {
                                self.returnUrl = "/";
                            }

                            this.loginSuccess();
                        });
                    }
                    else {
                        self.model.message = 'Invalid username/password.'
                    }
                        
                    this.loading = false;
                },
                error => {
                    //console.log("Error login");
                    this.loading = false;
                });
    }

    initialize() {
        var self = this;
        this.returnUrl = this.route.snapshot.params['returnUrl'] || '/';
        this.route.queryParams.subscribe((params) => {
            self.queryParams = params;
        });
    }

    loginSuccess(){
        if (_.isEmpty(this.queryParams) || this.returnUrl === "/") {
            this.router.navigate([this.returnUrl]);
        }
        else {
            this.router.navigate([this.returnUrl, this.queryParams]);
        }
        // this.dataservice.getConfiguration()
        //     .subscribe(
        //         data => {
        //             //console.log(this);
        //             this.router.navigate([this.returnUrl]);
        //         },
        //         error => {
        //             //console.log("Error login");
        //             this.loading = false;
        //         });
    }

    ngOnDestroy() {

    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/viewsmodule/login/login.component.ts